import UrlConfig from '@/api/UrlConfigs'
import {getChildrenDicts} from '@/services'
import {
  finishLaunchAccount,
  getAdvertWorkerList,
  getAgents,
  getBusinessLines,
  getChannels,
  getChannelTypeIds,
  getDataDictionaries,
  getDepartmentTree,
  getPlatforms,
  queryAllDecoCompany,
} from '@/services/getUsers'
import {CheckOutlined, CloseOutlined} from '@ant-design/icons'
import {Col, Divider, Empty, Form, Input, InputNumber, message, Row, Select, Switch, TreeSelect,} from 'antd'
import React, {useEffect, useState} from 'react'
import {SDrawerOrModal, SFuncModal, STitle} from 'shj-components'

const FormItem = Form.Item
const {Option} = Select
const {TreeNode} = TreeSelect

const renderTreeNodes = (data: any[], selectable: boolean) => {
  return data.map((item: any) => {
    if (item.children) {
      return (
        <TreeNode
          key={item.id}
          title={item.label}
          value={item.id}
          selectable={selectable}
          disabled={!selectable}
        >
          {renderTreeNodes(item.children, selectable)}
        </TreeNode>
      )
    } else {
      return <TreeNode key={item.id} title={item.label} value={item.id} {...item} />
    }
  })
}
const renderTreeNodeChannel = (data: any[], selectable: boolean) => {
  return data.map((item: any) => {
    if (item.children) {
      return (
        <TreeNode
          key={item.key}
          title={item.label}
          value={item.value}
          selectable={selectable}
          disabled={item.disabled}
        >
          {renderTreeNodeChannel(item.children, selectable)}
        </TreeNode>
      )
    } else {
      return <TreeNode key={item.key} title={item.label} value={item.value} {...item} />
    }
  })
}

const enabledTreeNode = (data: any[], fn: (node: any) => boolean) => {
  data.map((item: any) => {
    item.disabled = !fn(item)
    if (item.children) {
      enabledTreeNode(item.children, fn)
    }
  })
}

const SelectEmpty = (props: { description: string }) => {
  const {description = '暂无数据'} = props
  return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={description}/>
}

export const ModalAddOrEditDom = (props: { onClose: () => void; fn?: () => void; [key: string]: any }) => {
  const {onClose, fn, record} = props
  const id = record?.id
  const [form] = Form.useForm()
  const {setFieldsValue} = form
  const isEdit = () => !!(record && record.id)

  const [submitLoading, setSubmitLoading] = useState<boolean>(false)
  const [businessLines, setBusinessLines] = useState<any[]>([])
  const [companies, setCompanies] = useState<any[]>([])
  const [deptTree, setDeptTree] = useState<any[]>([])
  const [advertWorkers, setAdvertWorkers] = useState<any[]>([])
  const [channelTypeIds, setChannelTypeIds] = useState<any[]>([])
  const [armyAffiliations, setArmyAffiliations] = useState<any[]>([])
  const [channelTree, setChannelTree] = useState<any[]>([])
  const [channelTreeCache, setChannelTreeCache] = useState<any[]>([])
  const [platforms, setPlatforms] = useState<any[]>([])
  const [postBackTypes, setPostBackTypes] = useState<any[]>([])
  const [addOrEditData, setAddOrEditSubmitData] = useState<any>({})
  const [platformMap, setPlatformMap] = useState<any>({})
  const [operationModes, setOperationModes] = useState<any[]>([])
  const [agents, setAgents] = useState<any[]>([])
  const [bizOpTypeCodeList, setBizOpTypeCodeList] = useState<any[]>([]) // 需求标签
  const [productionType, setProductionType] = useState<any[]>([]) //钉钉产品

  const updateData = (data: any) => {
    setAddOrEditSubmitData(data)
    setFieldsValue(data)
  }

  // 获取所有下拉
  const initFn = async () => {
    getBusinessLines().then((list: any[]) => setBusinessLines(list))
    getChildrenDicts(['productionType']).then((list: any[]) =>
      setProductionType(list?.[0]?.children || [])
    )
    queryAllDecoCompany().then((res: any) => {
      setCompanies(res)
    })

    getChannelTypeIds().then((list: any[]) => setChannelTypeIds(list))
    getAgents().then((list: any[]) => setAgents(list))
    const armyAffiliationsList = await getDataDictionaries(
      'com.shj.saas.plus.clue.enums.ArmyAffiliation'
    )
    setArmyAffiliations(armyAffiliationsList)
    const operationModesList = await getDataDictionaries(
      'com.shj.saas.plus.clue.enums.account.OperationMode'
    )
    setOperationModes(operationModesList)
    const postBackTypesList = await getDataDictionaries('com.shj.saas.plus.clue.enums.BackClueType')
    postBackTypesList.forEach((item: Record<string, any>) => {
      item.label = item.description
      item.value = item.key
    })
    setPostBackTypes(postBackTypesList)

    const bizOpTypeCodeList = await getDataDictionaries('com.shj.saas.plus.crm.enums.BizOpTypeEnum')
    setBizOpTypeCodeList(bizOpTypeCodeList)
    getPlatforms().then((list: any[]) => {
      const map = {}
      list.forEach((item: any) => {
        map[item.platformCode] = item
      })

      setPlatforms(list)
      setPlatformMap(map)
    })

    if (record.deptId) {
      getDepartmentTree(record.companyId).then((departments: any) => {
        setDeptTree(departments)
      })
      getAdvertWorkerList({
        status: true,
        userIdentityFilter: {
          orgId: record.deptId,
        },
      }).then((list: any[]) => {
        setAdvertWorkers(list)
      })
    }

    getChannels().then((list: any[]) => {
      setChannelTreeCache(list)
      if (record.channelTypeId) {
        enabledTreeNode(list, (node: any) => node.typeId == record.channelTypeId)
        setChannelTree(list)
      }
    })
    if (record.intention == 'all') delete record.intention
    updateData(record)
  }

  useEffect(() => {
    if (props.open) initFn()
    return () => {
     form.resetFields()
    }
  }, [props.open]) // eslint-disable-line react-hooks/exhaustive-deps

  // 提交
  const onFinish = () => {
    form.validateFields().then((values: any) => {
      const data = {...values, ...addOrEditData}
      if (!data.advertId) {
        delete data.advertId
      }
      setSubmitLoading(true)
      const apiUrl = isEdit()
        ? UrlConfig.PlusClueWeb.LaunchAccountUpdateById
        : UrlConfig.PlusClueWeb.LaunchAccountOperate
      if (isEdit()) {
        data.id = id
      } else {
        delete data.launchIdentification
      }
      data.enableFlag = data.enableFlag ? true : false
      delete data.event
      delete data.methods
      delete data.selectedRowKeys
      delete data.selectedRows
      finishLaunchAccount(apiUrl, data)
        .then((resp: any) => {
          setSubmitLoading(false)
          // message.info(resp?.message);
          message.success(resp?.message || '操作成功')
          onClose()
          if (fn) {
            fn()
          }
        })
        .catch(() => {
          setSubmitLoading(false)
        })
    })
  }
  const onchange = (val: Record<string, any>) => {
    if (val.configMap) {
      const data = {...addOrEditData}
      data.configMap = {
        ...data.configMap,
        ...val.configMap,
      }
      setAddOrEditSubmitData(data)
    } else {
      setAddOrEditSubmitData({
        ...addOrEditData,
        ...val,
      })
    }
  }

  const onPlatformCodeChange = (platformCode: string) => {
    const platform = platformMap[platformCode]
    if (!platform) {
      return
    }

    const newData = {
      ...addOrEditData,
    }

    newData.platformConfigs = []
    platform?.configs.forEach((config: any) => {
      const value = newData && newData.configMap ? newData.configMap[config.configKey] : undefined
      newData.platformConfigs.push({
        ...config,
        value: value,
      })
    })

    updateData(newData)
  }

  // 辅助函数对于任何节点都检查子一级的状态来设置自己的状态.
  function traverseAndUpdate(list) {
    list.forEach(item => {
      if (!item.children || !item.children.length) return
      traverseAndUpdate(item.children)
      item.disabled = item.children.every(child => child.disabled)
    })
  }

  const changeChannelTypeId = (channelTypeId: string) => {
    if (channelTypeId === addOrEditData.channelTypeId) {
      return
    }
    if (!channelTypeId) {
      setChannelTree([])
      updateData({
        ...addOrEditData,
        channelTypeId: null,
        channelId: null,
      })
    } else {
      enabledTreeNode(channelTreeCache, (node: any) => node.typeId == channelTypeId)
      traverseAndUpdate(channelTreeCache)
      setChannelTree(channelTreeCache)
      updateData({
        ...addOrEditData,
        channelTypeId,
        channelId: null,
      })
    }
  }
  const onCompanyCodeChange = (companyId: string) => {
    if (!companyId || addOrEditData.companyId == companyId) {
      return
    }
    getDepartmentTree(companyId).then((departments: any) => {
      setDeptTree(departments)
      updateData({
        ...addOrEditData,
        companyId,
        deptId: null,
        advertId: null,
      })
    })
  }

  const onSelectDept = (deptId: string) => {
    if (!deptId) {
      setAdvertWorkers([])
      return
    }
    updateData({
      ...addOrEditData,
      deptId,
      advertId: null,
    })
    getAdvertWorkerList({
      status: true,
      userIdentityFilter: {
        orgId: deptId,
      },
    }).then((list: any) => {
      console.log(list, 'list')

      setAdvertWorkers(list)
    })
  }

  const renderConfigItem = (config: Record<string, any>) => {
    if (config.type === 'TEXT') {
      return <Input placeholder={`请输入${config.configName}`}/>
    } else if (config.type === 'PASSWORD') {
      return <Input placeholder={`请输入${config.configName}`} type={'PASSWORD'}/>
    } else if (config.type === 'SELECT') {
      return (
        <Select
          placeholder={`请选择${config.configName}`}
          showSearch
          allowClear={!config.required}
          filterOption={(input, option) => {
            return ((option?.children ?? '') + '').toLowerCase().includes(input.toLowerCase())
          }}
        >
          {config.options.map((option: any) => (
            <Option key={option.key} value={option.key}>
              {option.label}
            </Option>
          ))}
        </Select>
      )
    } else if (config.type === 'SWITCH') {
      return (
        <Switch
          checkedChildren={<CheckOutlined/>}
          unCheckedChildren={<CloseOutlined/>}
          defaultChecked={config.value === 'true'}
        />
      )
    }
  }

  const renderConfig = (config: Record<string, any>) => {
    return (
      <Col span={12} key={config.configKey}>
        <FormItem
          label={config.configName}
          name={['configMap', config.configKey]}
          rules={[{required: config.required, message: `请输入${config.configName}`}]}
        >
          {renderConfigItem(config)}
        </FormItem>
      </Col>
    )
  }

  const renderConfigs = () => {
    if (addOrEditData.platformConfigs && addOrEditData.platformConfigs.length > 0) {
      return (
        <>
          <Row gutter={12}>
            {addOrEditData.platformConfigs.map((config: any) => renderConfig(config))}
          </Row>
        </>
      )
    }
  }

  return (
    <SDrawerOrModal
      cancelText="取消"
      onCancel={onClose}
      onOk={onFinish}
      open={props.open}
      title={record?.id ? '编辑' : '新增'}
      confirmLoading={submitLoading}
    >
      {/* <div style={{width: '100%',height: '1px',position: 'absolute',background: 'rgba(217, 217, 217,1)',left: '0'}}></div> */}
      <Form
        form={form}
        autoComplete="off"
        onValuesChange={onchange}
        labelAlign={'right'}
        layout={'vertical'}
      >
        <Row gutter={12}>
          <Col span={12}>
            <FormItem
              label="投放账号ID"
              name="id"
            >
              <Input disabled={true} placeholder="由系统生成"/>
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem
              label="代理账号ID"
              name="proxyAccountId"
            >
              <InputNumber style={{width: '100%'}} placeholder="填写投放账号ID，不可填写自身"/>
            </FormItem>
          </Col>
        </Row>
        <Row gutter={12}>
          <Col span={12}>
            <FormItem
              label="投放平台"
              name="platformCode"
              rules={[{required: true, message: '请选择投放平台'}]}
            >
              <Select
                placeholder="请选择投放平台"
                allowClear
                disabled={isEdit()}
                onChange={onPlatformCodeChange}
                showSearch
                optionFilterProp="children"
              >
                {platforms &&
                  platforms.map((item: any) => (
                    <Option key={item.platformCode} value={item.platformCode}>
                      {item.platformName}
                    </Option>
                  ))}
              </Select>
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem label="投放标识" name="launchIdentification">
              <Input placeholder="如不填写则由系统自动生成投放标识，保存后不可编辑"/>
            </FormItem>
          </Col>
        </Row>
        <Row gutter={12}>
          <Col span={12}>
            <FormItem
              label="账户名称"
              name="accountName"
              rules={[{required: true, message: '账户名称不能为空'}]}
            >
              <Input placeholder="请输入账户名称"/>
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem
              label="账户ID"
              name="accountId"
              rules={[{required: true, message: '账户ID不能为空'}]}
            >
              <Input placeholder="请输入账户ID"/>
            </FormItem>
          </Col>
        </Row>
        <Row gutter={12}>
          <Col span={12}>
            <FormItem label="回传方式" name="postBackTypes">
              <Select
                placeholder="请选择"
                showSearch
                optionFilterProp="children"
                mode="multiple"
              >
                {postBackTypes &&
                  postBackTypes.map((item: any) => (
                    <Option key={item.key} value={item.key}>
                      {item.description}
                    </Option>
                  ))}
              </Select>
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem label="是否启用" name="enableFlag">
              <Switch
                checkedChildren="启用"
                unCheckedChildren="停用"
                checked={addOrEditData.enableFlag}
              />
            </FormItem>
          </Col>
        </Row>
        {renderConfigs()}
         <STitle title={'运营信息'} titleMode={'edit'} style={{marginBottom: 20}}/>
        <Row gutter={12}>
          <Col span={12}>
            <FormItem
              label="公司"
              name="companyId"
              rules={[{required: true, message: '请选择公司'}]}
            >
              <Select
                placeholder="请选择"
                showSearch
                onChange={onCompanyCodeChange}
                filterOption={(input, option: any) =>
                  option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
              >
                {companies &&
                  companies.map((item: any) => (
                    <Option key={item.orgId} value={item.orgId}>
                      {item.companyName}
                    </Option>
                  ))}
              </Select>
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem
              label="部门"
              name="deptId"
              rules={[{required: true, message: '请选择部门'}]}
            >
              <TreeSelect
                placeholder="请选择部门"
                treeNodeFilterProp="label"
                showSearch
                notFoundContent={<SelectEmpty description="请选择公司或无匹配数据"/>}
                onSelect={onSelectDept}
              >
                {deptTree && renderTreeNodes(deptTree, true)}
              </TreeSelect>
            </FormItem>
          </Col>
        </Row>
        <Row gutter={12}>
          <Col span={12}>
            <FormItem label="优化师" name="advertId">
              <Select
                placeholder="请选择"
                allowClear
                notFoundContent={<SelectEmpty description="请选择部门或无匹配数据"/>}
                showSearch
                optionFilterProp="children"
              >
                {advertWorkers &&
                  advertWorkers.map((item: any) => (
                    <Option key={item.id} value={item.id}>
                      {item.userName}
                    </Option>
                  ))}
              </Select>
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem
              label="军种"
              name="channelTypeId"
              rules={[{required: true, message: '请选择军种'}]}
            >
              <Select placeholder="请选择" allowClear onChange={changeChannelTypeId}
                      showSearch
                      optionFilterProp="children">
                {channelTypeIds &&
                  channelTypeIds.map((item: any) => (
                    <Option key={item.id} value={item.id}>
                      {item.typeName}
                    </Option>
                  ))}
              </Select>
            </FormItem>
          </Col>
        </Row>
        <Row gutter={12}>
          <Col span={12}>
            <FormItem
              label="总分归属"
              name="armyAffiliation"
              rules={[{required: true, message: '请选择总分归属'}]}
            >
              <Select placeholder="请选择" allowClear showSearch
                      optionFilterProp="children">
                {armyAffiliations &&
                  armyAffiliations.map((item: any) => (
                    <Option key={item.key} value={item.key}>
                      {item.description}
                    </Option>
                  ))}
              </Select>
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem
              label="渠道"
              name="channelId"
              rules={[{required: true, message: '请选择渠道'}]}
            >
              <TreeSelect
                placeholder="请选择渠道"
                treeNodeFilterProp="label"
                allowClear
                showSearch
                optionFilterProp="children"
                notFoundContent={<SelectEmpty description="请选择军种或无匹配数据"/>}
              >
                {channelTree && renderTreeNodeChannel(channelTree, false)}
              </TreeSelect>
            </FormItem>
          </Col>
        </Row>
        <Row gutter={12}>
          <Col span={12}>
            <FormItem
              label="品牌"
              name="channelBrandId"
              rules={[{required: true, message: '请选择品牌'}]}
            >
              <Select placeholder="请选择品牌" allowClear showSearch
                      optionFilterProp="children">
                {businessLines &&
                  businessLines.map((item: any) => (
                    <Option key={item.id} value={`${item.id}`}>
                      {item.brandName}
                    </Option>
                  ))}
              </Select>
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem label="产品意向" name="intention">
              <Select placeholder="请选择产品意向" allowClear showSearch
                      optionFilterProp="children">
                {productionType &&
                  productionType.map((item: any) => (
                    <Option key={item.priKey} value={`${item.priKey}`}>
                      {item.name}
                    </Option>
                  ))}
              </Select>
            </FormItem>
          </Col>
        </Row>
        <Row gutter={12}>
          <Col span={12}>
            <FormItem
              label="需求标签"
              name="bizOpTypeCode"
            >
              <Select placeholder="请选择需求标签" allowClear showSearch
                      optionFilterProp="children">
                {bizOpTypeCodeList &&
                  bizOpTypeCodeList.map((item: any) => (
                    <Option key={item.key} value={`${item.key}`}>
                      {item.description}
                    </Option>
                  ))}
              </Select>
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem
              label="运营方式"
              name="operationMode"
              rules={[{required: true, message: '请选择运营方式'}]}
            >
              <Select placeholder="请选择运营方式" allowClear showSearch
                      optionFilterProp="children">
                {operationModes &&
                  operationModes.map((item: any) => (
                    <Option key={item.key} value={`${item.key}`}>
                      {item.description}
                    </Option>
                  ))}
              </Select>
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem
              label="代理商"
              name="agentId"
            >
              <Select placeholder="请选择运营方式" allowClear showSearch
                      optionFilterProp="children">
                {agents &&
                  agents.map((item: any) => (
                    <Option key={item.id} value={`${item.id}`}>
                      {item.agentName}
                    </Option>
                  ))}
              </Select>
            </FormItem>
          </Col>
        </Row>
        {/* <Row style={{marginTop: '15px'}}>
                    <Col span={24} style={{ textAlign: 'right' }}>
                        <Button htmlType="button" onClick={onClose} style={{ margin: '0 8px' }}>
                            取消
                        </Button>
                        <Button loading={submitLoading} type="primary" style={{ marginLeft: '15px' }} htmlType="submit">
                            提交
                        </Button>
                    </Col>
                </Row> */}
      </Form>
      {/* <div style={{width: '100%',height: '1px',position: 'absolute',background: 'rgba(217, 217, 217,1)',left: '0',bottom: '65px'}}></div> */}
    </SDrawerOrModal>
  )
}

// export function modalAddOrEditFn(props: any) {
//   const {fn, title, ...record} = props
//   let dialog: any = 0
//   const onClose = () => {
//     (dialog as any)?.destroy()
//   }
//   dialog = SFuncModal({
//     width: 1000,
//     vanish: true,
//     title: record.record?.id ? '编辑' : '新增',
//     content: <ModalAddOrEditDom onClose={onClose} fn={fn} {...record} />,
//   })
//
//   return dialog
// }
